import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "card mb-5 mb-xl-10" }
const _hoisted_4 = { class: "card-header border-0" }
const _hoisted_5 = { class: "card-title m-0" }
const _hoisted_6 = { class: "fw-bolder m-0" }
const _hoisted_7 = { class: "collapse show" }
const _hoisted_8 = { class: "card-body border-top p-9" }
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_11 = { class: "col-lg-8 fv-row" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_16 = { class: "col-lg-8 fv-row" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "col-lg-8 fv-row" }
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "row mb-6" }
const _hoisted_30 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_31 = { class: "col-lg-8 fv-row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope fs-3" }, null, -1)
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "row mb-6" }
const _hoisted_36 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_37 = { class: "col-lg-8 fv-row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone fs-3" }, null, -1)
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_42 = { class: "pb-5" }
const _hoisted_43 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_44 = { class: "row mb-6" }
const _hoisted_45 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_46 = { class: "col-lg-8 fv-row" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fs-3" }, null, -1)
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "row mb-6" }
const _hoisted_51 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_52 = { class: "col-lg-8 fv-row" }
const _hoisted_53 = { class: "fv-plugins-message-container" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = { class: "row mb-6" }
const _hoisted_56 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_57 = { class: "col-lg-8 fv-row" }
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_62 = { class: "col-lg-8 fv-row" }
const _hoisted_63 = { class: "fv-plugins-message-container" }
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = { class: "card mb-5 mb-xl-10" }
const _hoisted_66 = { class: "card-header border-0" }
const _hoisted_67 = { class: "card-title m-0" }
const _hoisted_68 = { class: "fw-bolder m-0" }
const _hoisted_69 = { class: "collapse show" }
const _hoisted_70 = { class: "card-body border-top p-9" }
const _hoisted_71 = { class: "row mb-6" }
const _hoisted_72 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_73 = { class: "col-lg-8 fv-row" }
const _hoisted_74 = { class: "fv-plugins-message-container" }
const _hoisted_75 = { class: "fv-help-block" }
const _hoisted_76 = { class: "row mb-6" }
const _hoisted_77 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_78 = { class: "col-lg-8 fv-row" }
const _hoisted_79 = { class: "fv-plugins-message-container" }
const _hoisted_80 = { class: "fv-help-block" }
const _hoisted_81 = { class: "row mb-6" }
const _hoisted_82 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_83 = { class: "col-lg-8 fv-row" }
const _hoisted_84 = { class: "fv-plugins-message-container" }
const _hoisted_85 = { class: "fv-help-block" }
const _hoisted_86 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_87 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_88 = { class: "col-lg-8 fv-row" }
const _hoisted_89 = { class: "fv-plugins-message-container" }
const _hoisted_90 = { class: "fv-help-block" }
const _hoisted_91 = { class: "row mb-6" }
const _hoisted_92 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_93 = { class: "col-lg-8 fv-row" }
const _hoisted_94 = { class: "fv-plugins-message-container" }
const _hoisted_95 = { class: "fv-help-block" }
const _hoisted_96 = { class: "row mb-6" }
const _hoisted_97 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_98 = { class: "col-lg-8 fv-row" }
const _hoisted_99 = {
  class: "dropzone",
  id: "kt_dropzonejs_nuevos_documentosFamilia_nueva"
}
const _hoisted_100 = { class: "dz-message needsclick" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-3x" }, null, -1)
const _hoisted_102 = { class: "ms-4" }
const _hoisted_103 = { class: "fs-5 fw-bolder text-gray-900 mb-1" }
const _hoisted_104 = { class: "fs-7 fw-bold text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, { showBack: "" }, {
    actions: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.onSubmit,
        loading: _ctx.guardaDetalle,
        disabled: _ctx.isReading
      }, {
        default: _withCtx(() => [
          (!_ctx.isReading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.guardar.button")), 1))
            : (_ctx.isReading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.cargandoArchivos")), 1))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onClick", "loading", "disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, { type: "border-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('formularios.familiaDetalle.datosSolicitanteGroup')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("formularios.familiaDetalle.datosSolicitanteGroup")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_el_select, {
                          name: "tratamiento",
                          class: "w-100",
                          modelValue: _ctx.tratamiento,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tratamiento) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tratamientos, (tratamiento, i) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: i,
                                label: tratamiento.text,
                                value: tratamiento.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_ErrorMessage, { name: "tratamiento" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nombre.label")), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "nombre",
                              placeholder: " ",
                              modelValue: _ctx.nombre,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nombre) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_ErrorMessage, { name: "nombre" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "apellidos",
                              placeholder: " ",
                              modelValue: _ctx.apellidos,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apellidos) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_ErrorMessage, { name: "apellidos" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("formularios.familiaDetalle.dni.label")), 1),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "dni",
                          placeholder: " ",
                          modelValue: _ctx.dni,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dni) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_ErrorMessage, { name: "dni" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("formularios.familiaDetalle.email.label")), 1),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "email",
                          placeholder: " ",
                          modelValue: _ctx.email,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event))
                        }, {
                          append: _withCtx(() => [
                            _hoisted_32
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_ErrorMessage, { name: "email" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("formularios.familiaDetalle.telefono.label")), 1),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "telefono",
                          placeholder: " ",
                          modelValue: _ctx.telefono,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telefono) = $event))
                        }, {
                          append: _withCtx(() => [
                            _hoisted_38
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_ErrorMessage, { name: "telefono" })
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("h4", _hoisted_43, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccionGroup")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccion.label")), 1),
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "direccion",
                          placeholder: " ",
                          modelValue: _ctx.direccion,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.direccion) = $event))
                        }, {
                          append: _withCtx(() => [
                            _hoisted_47
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_ErrorMessage, { name: "direccion" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t("formularios.familiaDetalle.localidad.label")), 1),
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "localidad",
                          placeholder: " ",
                          modelValue: _ctx.localidad,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localidad) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_ErrorMessage, { name: "localidad" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t("formularios.familiaDetalle.comarca.label")), 1),
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.comarcaId,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.comarcaId) = $event)),
                          class: "w-100",
                          disabled: !_ctx.isAdmin
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.text,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_ErrorMessage, { name: "comarcaId" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t("formularios.familiaDetalle.provincia.label")), 1),
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_el_select, {
                          name: "provincia",
                          placeholder: " ",
                          modelValue: _ctx.provincia,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.provincia) = $event)),
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Huesca",
                              value: "Huesca"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Teruel",
                              value: "Teruel"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Zaragoza",
                              value: "Zaragoza"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_component_ErrorMessage, { name: "provincia" })
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('formularios.familiaDetalle.situacionFamiliarGroup')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("h3", _hoisted_68, _toDisplayString(_ctx.$t("formularios.familiaDetalle.situacionFamiliarGroup")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tipologiaFamilia.label")), 1),
                      _createElementVNode("div", _hoisted_73, [
                        _createVNode(_component_el_select, {
                          name: "tipologiaFamilia",
                          class: "w-100",
                          modelValue: _ctx.tipologiaFamilia,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tipologiaFamilia) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipologiasFamiliaTodas, (tipologiaFamilia, i) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: i,
                                label: tipologiaFamilia.nombre,
                                value: tipologiaFamilia.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _createVNode(_component_ErrorMessage, { name: "tipologiaFamilia" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t("formularios.familiaDetalle.numeroMenores.label")), 1),
                      _createElementVNode("div", _hoisted_78, [
                        _createVNode(_component_el_select, {
                          name: "tipologiaFamilia",
                          class: "w-100",
                          modelValue: _ctx.numeroMenores,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.numeroMenores) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numeroMenoresOpcionesTodas, (numeroMenores, i) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: i,
                                label: numeroMenores.nombre,
                                value: numeroMenores.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createVNode(_component_ErrorMessage, { name: "numeroMenores" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t("formularios.familiaDetalle.conIngresos.label")), 1),
                      _createElementVNode("div", _hoisted_83, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.conIngresos,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.conIngresos) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_component_ErrorMessage, { name: "conIngresos" })
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.conIngresos)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                          _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t("formularios.familiaDetalle.ingresos.label")), 1),
                          _createElementVNode("div", _hoisted_88, [
                            _createVNode(_component_CurrencyInput, {
                              modelValue: _ctx.ingresos,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ingresos) = $event)),
                              modelModifiers: { lazy: true },
                              options: {
                      currency: 'EUR',
                      locale: 'es-ES',
                      currencyDisplay: 'symbol',
                      precision: 2,
                      hideCurrencySymbolOnFocus: true,
                      hideGroupingSeparatorOnFocus: true,
                      hideNegligibleDecimalDigitsOnFocus: true,
                      autoDecimalDigits: false,
                      useGrouping: true,
                      accountingSign: false,
                    },
                              type: "text",
                              name: "ingresos",
                              class: "form-control form-control-lg",
                              placeholder: "ej. 11000.21"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_89, [
                              _createElementVNode("div", _hoisted_90, [
                                _createVNode(_component_ErrorMessage, { name: "ingresos" })
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.$t("formularios.familiaDetalle.familiaPrioritaria.label")), 1),
                      _createElementVNode("div", _hoisted_93, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.familiaPrioritaria,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.familiaPrioritaria) = $event)),
                          "validate-event": "false"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _createVNode(_component_ErrorMessage, { name: "familiaPrioritaria" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nuevosDocumentos.label")), 1),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, [
                          _createElementVNode("div", _hoisted_100, [
                            _hoisted_101,
                            _createElementVNode("div", _hoisted_102, [
                              _createElementVNode("h3", _hoisted_103, _toDisplayString(_ctx.$t(
                              "formularios.familiaDetalle.nuevosDocumentos.accion"
                            )), 1),
                              _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.$t(
                            "formularios.familiaDetalle.nuevosDocumentos.descripcion"
                          )), 1)
                            ])
                          ])
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          name: "certificadoAntecedentes",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}